import { StyledBubbleExplanation } from './BubbleExplanation.styled';
import {
  StyledBubbleText,
  StyledBubbleTextBox,
} from '../BubbleTextBox/BubbleTextBox.styled';
import { useEffect, useRef } from 'react';
import { notification } from 'antd';
import Colors from '@/constants/Colors';

export default function BubbleExplanation({ bubble, visible, onClose }) {
  const lastBubbleIdRef = useRef();

  useEffect(() => {
    if (visible && bubble) {
      if (lastBubbleIdRef.current != bubble.start) {
        notification.destroy();
        lastBubbleIdRef.current = bubble.start;
      }
      const placement = bubble.points[0][0] > 50 ? 'topLeft' : 'topRight';

      notification.open({
        placement,
        message: (
          <StyledBubbleExplanation>
            <div className="bubble-container">
              <div className="bubble">
                <StyledBubbleTextBox
                  key={`bubble-${bubble.id}`}
                  className={`bubble-${bubble.id}  bubble-text current`}
                  $points={[
                    [0, 0],
                    [100, 0],
                    [100, 100],
                    [0, 100],
                  ]}
                  style={{ display: 'block' }}
                >
                  <StyledBubbleText $texStyle={bubble.textStyle}>
                    {bubble.phrase.text}
                  </StyledBubbleText>
                  {bubble.explanation?.completeTranslation && (
                    <>
                      <strong>{'='}</strong>
                      <StyledBubbleText $texStyle={bubble.textStyle}>
                        <strong>
                          {bubble.explanation.completeTranslation}
                        </strong>
                      </StyledBubbleText>
                    </>
                  )}
                </StyledBubbleTextBox>
              </div>
            </div>
            <div
              className="explanation"
              dangerouslySetInnerHTML={{
                __html: bubble.explanation?.partsTranslations
                  ? bubble.explanation.partsTranslations
                  : bubble.explanation,
              }}
            ></div>
          </StyledBubbleExplanation>
        ),
        duration: 0,
        onClose,
        className: 'bubble-explanation',
        style: {
          backgroundColor: Colors.backgroundPaleBlue,
          border: `1px solid ${Colors.border}`,
          zIndex: 9999999,
        },
      });
    } else {
      notification.destroy();
    }
  }, [visible, bubble?.start]);

  return null;
}
